export default __webpack_public_path__ + "static/media/times.86536b23.svg";